import React from 'react';
import CustomersPage from './CustomersPage';
import CustomersPageMobile from './CustomersPageMobile';

const isMobile = () => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth <= 768;
};

const CustomersPageWrapper: React.FC = () => {
  const [mobile, setMobile] = React.useState(isMobile());

  React.useEffect(() => {
    const handleResize = () => {
      setMobile(isMobile());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return mobile ? <CustomersPageMobile /> : <CustomersPage />;
};

export default CustomersPageWrapper; 